import { ISchema, PaywallComponentProps } from '../@types'
import { mergeDeep } from '@/helpers/utils'
import beforeLegsPng from '@/assets/paywall/current-goal/before-legs.png'
import afterLegsPng from '@/assets/paywall/current-goal/after-legs.png'

const extensionSchema: ISchema = {
	components: {
		// mergeDeep swaps functions wholesale, so this has to restate every base prop, not just the images.
		PaywallCurrentGoal: ({ ctx, $t }): PaywallComponentProps.CurrentGoal => ({
			sex: 'female',
			targetWeight: ctx.localizedUserTargetWeight,
			weight: ctx.localizedUserTargetWeight,
			progressLabel: $t('female_yoga.pages.paywall.current_goal.activity_level'),
			currentBar: { image: beforeLegsPng },
			goalBar: { image: afterLegsPng },
		}),
	},
}

export default (schema: ISchema): ISchema => mergeDeep({ ...schema }, extensionSchema)
